import { ttcabinetsRUBConstants } from '../constants/ttcabinetsRUB';

const initialState = {
    currentState: 'loading',
    countries: {},
    categories: [],
    cabinets: [],
    error: '',
};

export default (state = initialState, action = {}) => {
    switch (action.type) {
        case ttcabinetsRUBConstants.SET_REQUEST_IN_PROGRESS_RUB:
            return { ...state, currentState: 'loading', error: initialState.error };
        case ttcabinetsRUBConstants.SET_SELECT_OPTIONS_SUCCESS_RUB:
            return {
                ...state,
                currentState: 'ready',
                countries: action.payload.countries,
                categories: action.payload.categories,
                error: initialState.error,
            };
        case ttcabinetsRUBConstants.SET_CABINETS_SUCCESS_RUB:
            return { ...state, currentState: 'ready', cabinets: action.payload };
        case ttcabinetsRUBConstants.SET_SELECT_OPTIONS_FAILURE_RUB:
        case ttcabinetsRUBConstants.SET_CABINETS_FAILURE_RUB:
            return { ...state, currentState: 'error', error: action.payload };
        default:
            return state;
    }
};
